module.exports = __webpack_public_path__ + "6fb23755a312b705c78c2e244df13e8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alt_logo.png
// module id = 167
// module chunks = 1